'use strict';
define([], function () {

    function pageSpecificComponent() {
        this.pageType = document.getElementById('pageType');
        this.pagetypefunction = this.pagetypefunction.bind(this);
        this.pageComponentOff = this.pageComponentOff.bind(this);
        this.init();
    }

    pageSpecificComponent.prototype.init = function () {
        var pageTypeElement = this.pagetypefunction();
        window.recentlyviewedEnabled = 'true';
        if (pageTypeElement && window.footerComponentSwitch) {
            var featureSwitchElements = window.footerComponentSwitch[pageTypeElement];
        }
        if (featureSwitchElements) {
            this.pageComponentOff(featureSwitchElements);
        }
    };
    pageSpecificComponent.prototype.pagetypefunction = function () {
        if (this.pageType) {
            var pageTypeText = this.pageType.innerText;
            return pageTypeText;
        }
        else {
            var pageUrlArray = window.location.pathname.split('/');
            for (var i = 0; i < pageUrlArray.length; i++) {
                switch (pageUrlArray[i]) {
                    case 'c':
                    case 's':
                        return 'STATIC';
                    case 'p':
                        return 'PDP';
                }
            }
        }
    };

    pageSpecificComponent.prototype.pageComponentOff = function (featureSwitchElements) {
        for (var Elements in featureSwitchElements) {
            if (featureSwitchElements.hasOwnProperty(Elements)) {
                var pagespecificcomponentDiv = document.getElementById(Elements);
                if (featureSwitchElements[Elements] === false && pagespecificcomponentDiv) {
                    pagespecificcomponentDiv.style.display = 'none';
                }
                if((Elements === 'recentlyviewedEnable') && (featureSwitchElements[Elements] === false)){
                    window.recentlyviewedEnabled = 'false';
                }
            }
        }

    };

    return pageSpecificComponent;

});



/** WEBPACK FOOTER **
 ** ./src/mns-core-ui-footer/templates/footer/js/pageSpecificComponent.js
 **/